import { CommentOutlined, StickyNote2Outlined } from "@mui/icons-material";
import { Divider, Stack, SxProps, Tooltip, Typography, useTheme } from "@mui/material";
import { Avatar, AvatarGroup, DueDateIcon, isWhitespace, TaskItemFocusCharm } from "src/components";
import { TaskItemDto } from "src/http";

interface IProps {
  taskItem: TaskItemDto;
  sx?: SxProps;
}

const TaskItemIcons = (props: IProps) => {
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      spacing={0.25}
      divider={<Divider orientation="vertical" sx={{ height: "12px" }} />}
      sx={props.sx}
      alignItems="center"
    >
      {props.taskItem.owners.length > 0 && (
        <>
          <AvatarGroup
            max={2}
            sx={{
              "& .MuiAvatar-root": { width: 20, height: 20, fontSize: 12 },
            }}
            users={props.taskItem.owners.map((x) => x.user)}
            avatarComponent={(user) => <Avatar user={user} tooltip />}
          />

          <TaskItemFocusCharm taskItem={props.taskItem} />
        </>
      )}

      {props.taskItem.note !== null && !isWhitespace(props.taskItem.note) && (
        <Tooltip title="Notes">
          <StickyNote2Outlined sx={{ color: theme.palette.grey[300] }} />
        </Tooltip>
      )}

      {props.taskItem.dueDate != null && <DueDateIcon dueDate={props.taskItem.dueDate} />}

      {props.taskItem.commentCount > 0 && (
        <Tooltip title="Comments">
          <Stack direction="row" spacing={0.1} sx={{ alignItems: "center" }}>
            <CommentOutlined sx={{ color: theme.palette.grey[300] }} />
            <Typography variant="caption">{props.taskItem.commentCount}</Typography>
          </Stack>
        </Tooltip>
      )}
    </Stack>
  );
};

export { TaskItemIcons };
